import { defineStore } from 'pinia'
import axios from 'axios'

export const PhysiciansStore = defineStore('Physicians', {
  state: () => ({
    query: {
      searchTerm: '',
      lastNameLetter: '',
      city: '',
      state: '',
      zipCode: '',
      language: '',
      gender: '',
      specialty: '',
      pageNumber: 1,
      resultsPerPage: 30
    },
    filterOptions: {
      locations: [],
      languages: [],
      genders: [],
      specialties: [],
    },
    queryStatus: 'loading',
    totalNumberOfResults: 0,
    physicians: [],
    filterOptionsStatus: 'loading',
    urlParametersStatus: 'loading',
    siteUrl: ''
  }),
  actions: {
    async getFilterOptions() {
      try {
        this.filterOptionsStatus = 'loading'
        if (window.siteUrl != "") {
          this.siteUrl = window.siteUrl;
        }
        const response = await axios.get(`${this.siteUrl}/webapi/physiciansapi/filteroptions`)
        this.filterOptions = response.data
        this.filterOptionsStatus = 'ready'
        return { success: true }
      }
      catch {
        this.filterOptionsStatus = 'error'
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async getResultsFromQuery() {
      try {
        this.queryStatus = 'loading'
        const response = await axios.post(`${this.siteUrl}/webapi/physiciansapi/query`, this.query)
        this.physicians = response.data.physicians
        this.totalNumberOfResults = response.data.totalNumberOfResults
        this.queryStatus = 'ready'
        this.updateUrlParametersFromQuery()
        return { success: true }
      } catch {
        this.queryStatus = 'error'
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async updateSearchTerm(searchTerm) {
      this.query.pageNumber = 1
      this.query.searchTerm = searchTerm
      await this.getResultsFromQuery()
    },
    async updateLastNameLetter(lastNameLetter) {
      this.query.pageNumber = 1
      this.query.lastNameLetter = lastNameLetter
      await this.getResultsFromQuery()
    },
    async updateFilters(location, zipCode, language, gender, specialty) {
      this.query.pageNumber = 1
      this.query.city = location?.city ?? ''
      this.query.state = location?.state ?? ''
      this.query.zipCode = zipCode
      this.query.language = language
      this.query.gender = gender
      this.query.specialty = specialty
      await this.getResultsFromQuery()
    },
    async updatePageNumber(pageNumber) {
      this.query.pageNumber = pageNumber
      await this.getResultsFromQuery()
    },
    async updateQueryFromUrlParameters() {
      this.urlParametersStatus = 'loading'
      if (window.siteUrl != "") {
        this.siteUrl = window.siteUrl;
      }
      const urlParameters = new URLSearchParams(window.location.search)
      if (urlParameters.has('page')) {
        this.query.pageNumber = window.parseInt(urlParameters.get('page'))
      }
      if (urlParameters.has('q')) {
        this.query.searchTerm = urlParameters.get('q')
      }
      if (urlParameters.has('lastnameletter')) {
        this.query.lastNameLetter = urlParameters.get('lastnameletter')
      }
      if (urlParameters.has('city') && urlParameters.has('state')) {
        this.query.city = urlParameters.get('city')
        this.query.state = urlParameters.get('state')
      }
      if (urlParameters.has('zipcode')) {
        this.query.zipCode = urlParameters.get('zipcode')
      }
      if (urlParameters.has('language')) {
        this.query.language = urlParameters.get('language')
      }
      if (urlParameters.has('gender')) {
        this.query.gender = urlParameters.get('gender')
      }
      if (urlParameters.has('specialty')) {
        this.query.specialty = urlParameters.get('specialty')
      }
      this.urlParametersStatus = 'ready'
    },
    async updateUrlParametersFromQuery() {
      const urlParameters = new URLSearchParams()
      if (this.query.pageNumber != 1) {
        urlParameters.append('page', this.query.pageNumber)
      }
      if (this.query.searchTerm) {
        urlParameters.append('q', this.query.searchTerm)
      }
      if (this.query.lastNameLetter) {
        urlParameters.append('lastnameletter', this.query.lastNameLetter)
      }
      if (this.query.city) {
        urlParameters.append('city', this.query.city)
      }
      if (this.query.state) {
        urlParameters.append('state', this.query.state)
      }
      if (this.query.zipCode) {
        urlParameters.append('zipcode', this.query.zipCode)
      }
      if (this.query.language) {
        urlParameters.append('language', this.query.language)
      }
      if (this.query.gender) {
        urlParameters.append('gender', this.query.gender)
      }
      if (this.query.specialty) {
        urlParameters.append('specialty', this.query.specialty)
      }
      const newUrl = new URL(window.location)
      newUrl.search = urlParameters.toString()
      window.history.replaceState(null, '', newUrl)
    },
  }
})
